import { Link } from "react-router-dom";
import { CheckCircle2, Phone, Mail } from "lucide-react";

export default function Grazie() {
  return (
    <div className="min-h-screen bg-brand-bg flex flex-col" data-testid="grazie-page">
      <header className="border-b border-brand-line bg-white/60 backdrop-blur-sm">
        <div className="max-w-3xl mx-auto px-6 py-4 flex items-center justify-center">
          <span className="font-heading text-lg text-brand-ink">24Vox</span>
        </div>
      </header>

      <main className="flex-1 flex items-center justify-center px-6 py-16">
        <div className="max-w-2xl text-center">
          <div className="w-20 h-20 mx-auto rounded-full bg-brand-olive flex items-center justify-center mb-8">
            <CheckCircle2 className="w-10 h-10 text-brand-bg" strokeWidth={1.5} />
          </div>

          <p className="text-xs font-medium tracking-[0.25em] text-brand-terra uppercase mb-4">Richiesta ricevuta</p>
          <h1 className="font-heading text-4xl md:text-5xl text-brand-ink mb-6 leading-tight" data-testid="grazie-title">
            Ti richiamo io.<br />
            <span className="italic text-brand-terra">Entro 24 ore.</span>
          </h1>
          <p className="text-lg text-brand-inkSoft mb-12 leading-relaxed">
            Ho appena ricevuto la tua richiesta. Nelle prossime 24 ore ti chiamo personalmente al numero che mi hai lasciato. Niente commerciali, niente segretarie. Solo io e te.
          </p>

          <div className="bg-white border border-brand-line rounded-2xl p-8 mb-10">
            <h2 className="font-heading text-xl text-brand-ink mb-6">Cosa succede adesso</h2>
            <div className="space-y-5 text-left">
              {[
                { n: "01", t: "Lara analizza il tuo sito a fondo", s: "La nostra AI analista studia ogni angolo del tuo sito per costruire la 24Vox più precisa possibile" },
                { n: "02", t: "Ti chiamo io entro 24h", s: "Capisco le tue specificità, rispondiamo insieme alle prime obiezioni" },
                { n: "03", t: "Attiviamo la tua 24Vox", s: "In 5 minuti la tua AI vocale è online sul tuo numero. Senza tu debba toccare niente." },
              ].map((s, i) => (
                <div key={i} className="flex gap-4">
                  <div className="font-heading text-2xl text-brand-terra leading-none w-10 shrink-0">{s.n}</div>
                  <div>
                    <p className="font-heading text-base text-brand-ink mb-1">{s.t}</p>
                    <p className="text-sm text-brand-inkSoft">{s.s}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="flex flex-col sm:flex-row gap-3 justify-center mb-8">
            <a href="mailto:robs@24vox.it" className="px-6 py-3 rounded-lg border border-brand-line text-brand-ink hover:bg-white transition-colors flex items-center justify-center gap-2 text-sm" data-testid="grazie-email">
              <Mail className="w-4 h-4" />
              robs@24vox.it
            </a>
            <Link to="/" className="px-6 py-3 rounded-lg btn-olive font-semibold text-sm flex items-center justify-center gap-2" data-testid="grazie-home">
              Torna alla home
            </Link>
          </div>

          <p className="text-sm text-brand-inkSoft italic">
            P.S. Se sei impaziente come me, scrivimi direttamente o chiamami. Rispondo io.
          </p>
        </div>
      </main>
    </div>
  );
}
